export default "<app-shared-article-price-total [values]=\"{articlePrice: price, quantity: quantity}\"></app-shared-article-price-total>";